import { combineReducers } from "redux";
import { homeCarouselReducer } from "./homeCarouselReducer";
import { detalleServicioReducer } from "./detalleServicioReducer";
import { equipoReducer } from "./equipoReducer";

export const rootReducers = combineReducers ({
    homeCarousel: homeCarouselReducer,
    detalleServicio: detalleServicioReducer,
    equipo: equipoReducer
})